<div class="m-3 d-flex flex-column flex-md-row align-items-md-end align-self-md-end">
  @if (filterType === 'checkbox') {
    <app-pascom-checkbox
      class="d-none d-md-block"
      (acceptChanged)="checkboxFilterChanged.emit($event)"
    [text]="checkboxFilterText"></app-pascom-checkbox>
  }
  @if ((filterType === 'multi' || filterType === 'both') && showDropdown) {
    <app-pascom-dropdown
      class="mb-2 mb-md-0 filter-dropdown"
      [dropdownOptions]="multiFilterOptions"
      [selectedDropdownOptions]="multiSelectedDefault"
      (selectedOptionsEventEmitter)="multiFilterChanged.emit($event)"
      [placeholder]="multiPlaceholder"
      [display]="multiFilterDisplay"
    [filter]="multiFilterSearch"></app-pascom-dropdown>
  }

  <div class="d-flex ml-md-auto">
    <div class="d-none d-md-block ml-auto filter-search-wrapper">
      <app-searchbox (filterChanged)="searchFilterChanged.emit($event)" [placeholder]='placeholder' [onSearching]="onSearching"></app-searchbox>
    </div>

    <div class="d-flex d-md-none w-100">
      <app-searchbox (filterChanged)="searchFilterChanged.emit($event)" [placeholder]="placeholder" [onSearching]="onSearching"></app-searchbox>
    </div>


  </div>
</div>
<div class="d-block d-md-none ml-3 mb-3">
  @if (filterType === 'checkbox') {
    <app-pascom-checkbox
      (acceptChanged)="checkboxFilterChanged.emit($event)"
    [text]="checkboxFilterText"></app-pascom-checkbox>
  }
</div>
<div class="ml-3 mb-3">
  @if (filterType === 'both') {
    <app-pascom-checkbox
      (acceptChanged)="checkboxFilterChanged.emit($event)"
    [text]="checkboxFilterText"></app-pascom-checkbox>
  }
</div>



